// extracted by mini-css-extract-plugin
module.exports = {"mediaPosts":"MediaFeed_mediaPosts__YYOSB"};